import { Routes } from '@angular/router';
import { EntryComponent } from './entry/entry.component';
import { ZipManagerInitGuard } from './zip-manager.init-guard';
import { ZipManagerRouting } from '@aipb/gulliver/zip-manager/routing';

export const ZipManagerRoutes: Routes = [
  {
    path: '',
    redirectTo: 'default',
    pathMatch: 'prefix'
  },
  {
    path: ZipManagerRouting.configPath,
    component: EntryComponent,
    providers: [ZipManagerInitGuard],
    canActivate: [ZipManagerInitGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: ZipManagerRouting.dashboardPath
      },
      {
        path: ZipManagerRouting.dashboardPath,
        loadChildren: () => import('@aipb/gulliver/zip-manager/feature-dashboard').then((m) => m.DashboardRoutes)
      }
    ]
  }
];
